import moment from "moment";

// TODO: Document it
class DateTimeFormatter {

  format(value, format = "DD.MM.YYYY") {
    let date = moment.utc(value);
    return date.format(format);
  }
}

const instance = new DateTimeFormatter();
export default instance;